import { useCallback } from 'react';
import { ImageURISource } from 'react-native';
import { ListRenderItemInfo } from '@shopify/flash-list';

import { FlashList } from '../FlashList';
import { ContactItem } from '../ContactItem';
import { CircleDoneIcon } from '../../assets';

export const ContactsSelect = ({
	mode,
	contacts,
	selectedIds,
	setSelectedIds,
}: ContactSelectProps) => {
	const handleContactPress = useCallback(
		(isSelected: boolean, contactId: string) => () => {
			if (isSelected) {
				return setSelectedIds(selectedIds.filter((id) => id !== contactId));
			}

			if (mode === 'multi') {
				return setSelectedIds([...selectedIds, contactId]);
			}

			setSelectedIds([contactId]);
		},
		[mode, selectedIds, setSelectedIds],
	);

	const renderItem = useCallback(
		({ item: { id, name, photoSource } }: ListRenderItemInfo<Contact>) => {
			const isSelected = selectedIds.includes(id);

			return (
				<ContactItem
					key={id}
					name={name}
					photoSource={photoSource}
					onPress={handleContactPress(isSelected, id)}
					action={<CircleDoneIcon selected={isSelected} />}
				/>
			);
		},
		[handleContactPress, selectedIds],
	);

	return (
		<FlashList
			data={contacts}
			extraData={selectedIds}
			estimatedItemSize={64}
			renderItem={renderItem}
		/>
	);
};

export type ContactSelectProps = {
	mode: 'single' | 'multi';
	contacts: Contact[];
	selectedIds: string[];
	setSelectedIds: (ids: string[]) => void;
};

export interface Contact {
	id: string;
	name: string;
	photoSource?: ImageURISource;
}
